import {
    Box,
    useColorModeValue,
    HStack,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    Button,
    useDisclosure,
    Image,
    Card, CardHeader, CardBody, CardFooter,
    Stack,
    Heading,
    Text,
    Divider,
    ButtonGroup,
    VStack,
    SimpleGrid,
    AspectRatio,
} from '@chakra-ui/react';

import { TfiClose } from "react-icons/tfi";
import { ChevronRightIcon } from '@chakra-ui/icons';

import React, { } from "react";

import balc from '../assets/core2/r10_verandabalc.png'
import movie from '../assets/core2/movie.png'
import plan from '../assets/core2/PLAN_REV01.png'
import sxn from '../assets/core2/SECTION_REV02.png'
import planrender from '../assets/core2/plan-render.png'
import cyclist from '../assets/core2/r8_REV01_cyclist.png'
import cycling from '../assets/core2/r5cycling.png'
import epic from '../assets/core2/epic.png'
import hero from '../assets/core2/r35_hero-sq.png'
import aesthetic from '../assets/core2/aesthetic_r17_actual1.png'
import datenight from '../assets/core2/r33_datenight.png'
import context from '../assets/core2/gearth.png'
import aerial from '../assets/core2/k33_aerial.png'
import aerialclose from '../assets/core2/r17_aerial_close.png'
import model from '../assets/core2/model.png'
import lunchbreak from '../assets/core2/12pmlunchbreak.png'
import aerial2 from '../assets/core2/r3aerialrev01.png'
import aerialclose2 from '../assets/core2/r18-427_aerial.png'
import yoga from '../assets/core2/r31-yoga.png'
import night from '../assets/core2/night.jpg'
import overall from '../assets/core2/overall_r7.png'
import site from '../assets/core2/site.png'
import splashpad from '../assets/core2/r38-splashpad.png'
import damagesystem from '../assets/core2/damagesystem.png'
import work from '../assets/core2/work.gif'
import school from '../assets/core2/r26_3pmafterschool.png'
import grocer from '../assets/core2/r37-4grocerREV01.png'
import week from '../assets/core2/week.png'
import beforemap from '../assets/core2/before1bw.png'
import beforeelevation from '../assets/core2/before2.png'
import core2cover from '../assets/core2_foodmarket.png'
import nwkBefore from  '../assets/core2/concept-nwk_before.png'
import nwkAfter from  '../assets/core2/concept-nwk_after.png'

export default ProjectModalCore2;

function ProjectModalCore2() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [size, setSize] = React.useState('md')

    const handleSizeClick = (newSize) => {
        setSize(newSize)
        onOpen()
    }

    const sizes = ['full']

    return (
        <>
            {sizes.map((size) => (
                <Button
                    onClick={() => handleSizeClick(size)}
                    key={size}
                    textAlign='left'
                    fontWeight='medium'
                    fontSize={{ base: 'sm', lg: 'sm' }}

                    // p={'-4'}
                    borderRadius={'lg'}
                    border={'1px'}
                    bg={'transparent'}
                    _hover={{
                        transform: "scale(0.98)",
                        transition: 'all .1s ease',
                        color: 'gray.500',
                        bg: 'transparent'
                    }}
                    _active={{
                        transform: "scale(0.96)",
                        transition: 'all .1s ease',
                        color: 'gray.800',
                    }}
                >
                    {/* {`Open ${size} Modal`} */}
                    {`Learn More`}
                    <ChevronRightIcon boxSize={6}
                        // w={8} h={8} 
                        color="pink.400" />
                </Button>
            ))}

            <Modal onClose={onClose} size={size} isOpen={isOpen} blockScrollOnMount={false}>
                <ModalOverlay />
                <ModalContent>
                    <HStack justify={'flex-end'}>
                        <Button onClick={onClose}
                            // justify={'space-between'}
                            align={'left'}
                            _hover={{
                                transform: "scale(0.98)",
                                transition: 'all .1s ease',
                                color: 'gray.500',
                                bg: 'transparent'
                            }}
                            _active={{
                                transform: "scale(0.96)",
                                transition: 'all .1s ease',
                                color: 'gray.800',
                            }}
                            bg={'transparent'}
                        >
                            <TfiClose boxSize={24} />
                        </Button>
                    </HStack>


                    <ModalHeader
                        fontSize={{ base: '3xl', sm: '4xl' }}
                        color={useColorModeValue('black', 'white')}
                        fontWeight='thin'
                        textAlign='center'
                        lineHeight='1'
                        mt={"10px"}
                        mb={"10px"}
                    >
                        <Text
                            textTransform='uppercase'
                            letterSpacing={2}> Urban Renewal and Bioregeneration </Text>
                        <Text
                            letterSpacing={0}
                            my={5}
                            textAlign='center' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
                            color={useColorModeValue('gray.800', 'gray.200')}
                        >
                            📍 281-285 Ferry St, Ironbound, Newark, NJ 07105
                        </Text>
                    </ModalHeader>
                    {/* <ModalCloseButton/> */}

                    <ModalBody>
                        <Box p={'-4'}>
                            { }
                            <ProjectGrid />
                        </Box>
                    </ModalBody>
                    {/* <ModalFooter> <Button onClick={onClose}>Close</Button> </ModalFooter> */}
                </ModalContent>
            </Modal>
        </>
    )
}

const ProjectGrid = () => {
    return (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>


            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={beforeelevation}
                        alt='Before'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Initial State</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={core2cover}
                        alt='Intervention'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Intervention</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={hero}
                        alt='Welcome'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Day</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={beforemap}
                        alt='Render: Plan'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Responding to Dioxin Pollution and Surface Parking with Bioremediation</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={planrender}
                        alt='Render: Plan'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Plan</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={plan}
                        alt='Plan'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Plan: Civic Space</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={sxn}
                        alt='Section'
                        border={'1px'}
                        borderColor={'gray.300'}
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Canopy-Building Section: Vertical Urban Farming and Grocery Store</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={nwkBefore}
                        alt='nwk before'
                    />
                </AspectRatio>
                <Text
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Current State: Polluted by Industry and Dioxins</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={nwkAfter}
                        alt='nwk after'
                    />
                </AspectRatio>
                <Text
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Goal: Ecological Restoration</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={yoga}
                        alt='Yoga'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Yoga | Sunday 6:45am</Text>
            </VStack>

            <VStack>
                <AspectRatio
                    // w={'100%'} 
                    w={'full'}
                // w={'lg'}
                // ratio={1}
                >
                    <Image
                        src={work}
                        alt='Work'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    WFH Meeting | Monday 7:00am</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={cycling}
                        alt='Cycling'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Cycling to Coworking Space | Tuesday 8:30am</Text>
            </VStack>


            <VStack>
                <AspectRatio
                    w={'full'}
                    ratio={1}
                >
                    <Image
                        src={school}
                        alt='school'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    After School Gathering | Wednesday 3:00pm</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={datenight}
                        alt='Lunch Date'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Outdoor Music, Spontaneous Encounters | Thursday 4:00pm</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={splashpad}
                        alt='splashpad'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Splashpad, Watching the Kids | Friday 5:00pm</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={balc}
                        alt='Veranda Balcony'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Relaxing over the Veranda | Friday 5:30pm</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={movie}
                        alt='Movie Screening'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Movie Screening | Friday 8:00pm</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={grocer}
                        alt='grocer'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Locally-Grown Grocery Shopping | Saturday 4:30pm</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={night}
                        alt='night'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Neighborhood Identity: Passing by, Heading Home | 9:00pm</Text>
            </VStack>


            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={cyclist}
                        alt='Cycling'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                </Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={epic}
                        alt='Epic Hero Shot'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Canopies</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={overall}
                        alt='Overall'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                </Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={aerialclose2}
                        alt='Aerial'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Aerial Close up 4:30pm</Text>
            </VStack>


            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={lunchbreak}
                        alt='Lunch Break'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Hanging out</Text>
            </VStack>

            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={context}
                        alt='Context'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Context: Ironbound, Newark, NJ</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={site}
                        alt='Site'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Site</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={damagesystem}
                        alt='Damage System'
                    />
                </AspectRatio>
                <Text
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Damage System: Dioxin Pollution, Surface Parking</Text>
            </VStack>
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={aerial}
                        alt='Render: Aerial'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Aerial</Text>
            </VStack>
            {/* <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={aerial2}
                        alt='Aerial'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Aerial</Text>
            </VStack> */}
            <VStack>
                <AspectRatio w={'full'} ratio={1}>
                    <Image
                        src={model}
                        alt='model'
                    />
                </AspectRatio>
                <Text
                    // size='md'
                    textAlign='center'
                    fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
                    color={useColorModeValue('gray.800', 'gray.200')}
                >
                    Model: 3D Printing</Text>
            </VStack>
        </SimpleGrid>
    );
};
